import React, {useEffect, useState} from 'react';
import {Collapse} from 'antd';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {FaqsService} from "../../../../services/faq-api-service";
import FaqSkeleton from "../../../skeletons/setting/FaqSkeleton";

export default function Faqs() {
    const [faqsData, setFaqsData] = useState([])
    const [loader , setLoader] = useState(true)
    const { Panel } = Collapse;
    const text = `
 This is dummy copy. It is not meant to be read. It has been placed here solely to demonstrate the look and feel of finished, typeset text. Only for show. He who searches for meaning here will be sorely disappointed.
`;
    const items = [
        {
            key: '1',
            label: faqsData.question,
            children: <p>{faqsData.answer}</p>,
        },
        {
            key: '2',
            label: 'Where can I subscribe to your newsletter?',
            children: <p>{text}</p>,
        },
        {
            key: '3',
            label: 'Where can I subscribe to your newsletter?',
            children: <p>{text}</p>,
        },
        {
            key: '4',
            label: 'Where can I subscribe to your newsletter?',
            children: <p>{text}</p>,
        },
    ];

    async function GetFaqs() {
        setLoader(true)
        const response = await FaqsService.getFaqs();
        if(response?.data?.data?.status){
            setFaqsData(response.data?.data?.data?.result)
            setLoader(false)
        }
    }

    useEffect(()=>{
        GetFaqs()
    },[1000])

    const onChange = (key) => {

    };
    const customExpandIcon = ({ isActive }) => {
        return isActive ? <MinusOutlined style={{ color: '#F95C59', fontSize: '18px' }}/> : <PlusOutlined style={{ color: '#D2A84E', fontSize: '18px' }} />;
    };

    if(loader){
        return <FaqSkeleton/>
    }

    return(

        <div className={'faqs'}>
            <h6 className={'faqs-heading'}>FAQ’s</h6>
            <p className={'sub-head'}>you can submit any query regarding anything to us our rise up king moderator will response you as soon as possible.</p>
            <Collapse accordion onChange={onChange} expandIconPosition={'end'}   expandIcon={customExpandIcon}>
                {faqsData.map((faq) => (
                    <Panel key={faq._id} header={faq.question}>
                        <p> {faq.answer}</p>
                    </Panel>
                ))}
            </Collapse>;
        </div>
    )
};
